/**
 * Storage usage is computed on the server from what is actually stored. When
 * something that changes it succeeds (a slide or file is deleted, an upload
 * finishes), fire this so the storage bar re-fetches instead of showing the
 * total from when the page loaded.
 */
export const STORAGE_CHANGED_EVENT = "microlab:storage-changed";

export function notifyStorageChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(STORAGE_CHANGED_EVENT));
}
